<div style="padding: 1rem;">
  {{ 'msg.user.rawmaterial.popin.facultative-error.intro' | translate }}
  <ul>
      <li>
        {{ computeWithMeta.facultativeErrorDetail }}
      </li>
  </ul>
  <div class="asi-container" fxLayoutAlign="center center">
    <button
      pButton
      class="neq-primeng-button-text"
      (click)="closeDialog()"
      label="{{'msg.common.validation.ok' | translate}}"></button>
  </div>
</div>
